import React from "react";
import ReactPaginate from "react-paginate";
import "./Pagination.css";
const Pagination = ({ PageCount, onPress, ForceCount }) => {
  const handlePageClick = (data) => {
    onPress(data.selected + 1);
  };
  return (
    <ReactPaginate
      breakLabel="..."
      nextLabel="التالى"
      onPageChange={handlePageClick}
      marginPagesDisplayed={2}
      forcePage={ForceCount}
      pageRangeDisplayed={2}
      pageCount={PageCount}
      renderOnZeroPageCount={null}
      previousLabel="السابق"
      containerClassName={"pagination justify-content-center p-3"}
      pageClassName={"page-item"}
      pageLinkClassName={"page-link"}
      previousClassName={"page-item"}
      nextClassName={"page-item"}
      previousLinkClassName={"page-link"}
      nextLinkClassName={"page-link"}
      breakClassName={"page-item"}
      breakLinkClassName={"page-link"}
      activeClassName={"active"}
    />
  );
};

export default Pagination;
